import React from "react";
import PropTypes from "prop-types";
import PCandSkinDesktop from "./PCandSkinDesktop";

function PositivacaoCategory({ app, config }) {
  return <PCandSkinDesktop app={app} config={config} />;
}

PositivacaoCategory.defaultProps = {
  app: null,
  config: {},
};

PositivacaoCategory.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoCategory;
